import { processRequest } from '../../services/Api';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import { methodDetailsActionTypes } from './Constants';
import * as methodDetailsActions from './Actions';
import * as errorHandlerActions from '../../components/errorHandler/Actions';

export default function* () {
	yield all([
		takeLatest(methodDetailsActionTypes.GET_METHOD_DETAILS_REQUEST, handleMethodDetailsRequest),
	]);
}

export function* handleMethodDetailsRequest({ payload }) {
	try {
		const { id, query } = payload || {};

		const { data } = yield call(processRequest, `public/publisher_methods/${id}`, 'GET', query);
		yield put(methodDetailsActions.getMethodDetailsSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(methodDetailsActions.getMethodDetailsError());
	}
}
